<script>
  import options from './SelectedBulkOverview.options'
  export default options
</script>

<template>
  <article class="nlx-selected-bulk-overview">
    <template v-if="spinnerVisible">
      <div class="nlx-loading-spinner-overlay">
      <div class="nlx-loading-spinner"></div>
      </div>
    </template>

    <template v-if="!noSelectedProducts">
      <TableComponentGeneric v-model:tableData="productTableData"/>
      
      <button class="nlx-button nlx-button--confirm" :disabled="spinnerVisible || noSelectedProducts || !userIsLoggedIn || addToCartDisabled" @click="addToCart()">{{ getLabel('addToCart') }}</button>
      <p v-if="addToCartDisabled" class="nlx-selected-bulk-overview__disabled-message">{{ addToCartDisabledMessage }}</p>
    </template>

  </article>
</template>
